module.exports = __webpack_public_path__ + "static/media/careersinc_logo.93741570.png";